import React, { useEffect } from 'react';
import Banner from '../Components/Banner';
import BannerImage from "../Images/blog-banner.jpg";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import BlogData from "../Data/BlogData";
import "./Css/Blog.css";
import Slider from "react-slick";

const BlogInner = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.key])
  const blog = location.state?.blog;

  const navigate = useNavigate();

  if (!blog) {
    // If blog not found (user refreshed), go back or show fallback
    return (
      <div style={{ padding: '2rem' }}>
        <h2>Blog not found.</h2>
        <button onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  const bannerTitle = <>{blog.title}</>;
  const bannerContent = "";
  const bannerConclude = "";
  const otherBlogs = BlogData.filter(b => b.id !== blog.id);
  const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3, 
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 992, // For tablets and below
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 576, // For mobile
      settings: {
        slidesToShow: 1
      }
    }
  ]
};
  return (

    <>
    <Banner
        image={BannerImage}
        propAlt="Home Banner"
        bannerTitle={bannerTitle}
        bannerContent={bannerContent}
        bannerConclude={bannerConclude}
      />
       <section className="section-pad blog-inner">
        <Container>
          <h3 className='title text-center mb-5'>
            {blog.title}
          </h3>
          <img className='img-responsive' src={blog.bannerImage} alt={blog.title} style={{ maxWidth: '100%' }} />
          <div className='mt-5 text-justify'>
            {blog.content.map((block, idx) => {
              switch (block.type) {
                case 'heading':
                  return <h4 key={idx} className="mb-3 mt-4">{block.text}</h4>;
                case 'paragraph':
                  return <p key={idx} className="text-justify">{block.text}</p>;
                case 'list':
                  return (
                    <ul key={idx} className="custom-list">
                      {block.items.map((item, i) => (
                        <li key={i} className="d-flex align-items-start gap-2 mb-2">
                          <FontAwesomeIcon icon={faCircleCheck} className="text-success mt-1" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  );
                default:
                  return null;
              }
            })}

          </div>
        </Container>
      </section>
      {/* <section className="section-pad bg-light mt-5">
        <Container>
          <h4 className="mb-4 text-center">More for you</h4>
          <Row>
            {otherBlogs.map((item) => (
              <Col key={item.id} md={4} className="mb-4">
                <Link
                  to={item.link}
                  state={{ blog: item }}
                  className="text-decoration-none"
                >
                  <div className="card h-100 explore-more">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="card-img-top"
                    />
                    <div className="card-body">
                      <h6 className="card-title text-center">{item.title}</h6>
                    </div>
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        </Container>
      </section> */}

      <section className="section-pad bg-light mt-5">
    <Container>
      <h4 className="mb-5 text-center">More for you</h4>
      {otherBlogs.length > 1 ? (
        <Slider {...settings}>
          {otherBlogs.map((item) => (
            <div key={item.id} className="px-2">
              <Link
                to={item.link}
                state={{ blog: item }}
                className="text-decoration-none"
              >
                <div className="card h-100 explore-more">
                  <img
                    src={item.listImage}
                    alt={item.title}
                    className="card-img-top"
                  />
                  <div className="card-body">
                    <h6 className="card-title text-center">{item.title}</h6>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Slider>
      ) : (
        <Row>
          {otherBlogs.map((item) => (
            <Col md={6} key={item.id}>
              <Link
                  to={item.link}
                  state={{ blog: item }}
                  className="text-decoration-none"
                >
                  <div className="card h-100 explore-more">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="card-img-top"
                    />
                    <div className="card-body">
                      <h6 className="card-title text-center">{item.title}</h6>
                    </div>
                  </div>
                </Link>
            </Col>
          ))}
        </Row>
      )}

    </Container>
  </section>
  {/* <section>

    <Container>
      <Slider {...settings}>
          {otherBlogs.map((item) => (
            <div key={item.id} className="px-2">
              <Link
                to={item.link}
                state={{ blog: item }}
                className="text-decoration-none"
              >
                <div className="card h-100 explore-more">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="card-img-top"
                  />
                  <div className="card-body">
                    <h6 className="card-title text-center">{item.title}</h6>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Slider>
    </Container>
  </section> */}

    </>
   
  );
};

export default BlogInner;
